import type { UserPreferenceEntity } from '@unifyapps/carbon/hooks/useUserPreferenceMutation/utils';
import { buildGetUserPreferencePayloadRequest } from '@unifyapps/carbon/hooks/useUserPreferenceMutation/utils';
import { UAModules } from '@unifyapps/defs/types/modules';
import { useExecuteWorkflowNode } from '@unifyapps/network/generated/workflow-rest-api/workflow-rest-api';
import { useMemo } from 'react';
import { useIsUserLoggedIn } from '../../hooks/useIsUserLoggedIn';
import { getUserPreferenceTriggerInputCondition } from '../../hooks/useUserPreferenceMutation/utils';
import { COLOR_SCHEME_USER_PREFERENCE_KEY, THEME_USER_PREFERENCE_KEY } from '../const';
import { useGlobalAppStateStore } from '../stores/app/GlobalAppStateStore';
import { InterfaceModes } from '../stores/InterfaceStore/types';

export const getThemeUserPreferenceTriggerInputCondition = (interfaceId = '') => {
  return getUserPreferenceTriggerInputCondition({
    applicationId: interfaceId,
    module: UAModules.INTERFACE,
    recordId: interfaceId,
    key: [COLOR_SCHEME_USER_PREFERENCE_KEY, THEME_USER_PREFERENCE_KEY],
  });
};

export function useThemeUserPreference(interfaceId?: string) {
  const mode = useGlobalAppStateStore().hooks.useMode();
  const isRunnerMode = mode === InterfaceModes.RUNNER;
  const shouldFetchUserPreference = useIsUserLoggedIn() && isRunnerMode;

  const executeWorkflowNodeRequest = useMemo(
    () =>
      buildGetUserPreferencePayloadRequest({
        triggerInputCondition: getThemeUserPreferenceTriggerInputCondition(interfaceId),
      }),
    [interfaceId],
  );

  const { data: userPreferenceThemeData, isLoading: isUserPreferenceThemeIdLoading } =
    useExecuteWorkflowNode<{ response: { userPreferences: UserPreferenceEntity[] } }>(
      executeWorkflowNodeRequest,
      {
        query: {
          enabled: shouldFetchUserPreference,
        },
      },
    );
  const userPreferenceThemeId =
    userPreferenceThemeData?.response?.userPreferences?.[0]?.properties.value;

  return {
    userPreferenceThemeId,
    isUserPreferenceThemeIdLoading,
  };
}
